import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ROUTES } from '@/router/routes'
import { useResidentialComplexStore } from '@/features/residential-complex/stores/residentialComplexStore'
import { useArticlesStore } from '@/features/articles/stores/articlesStore'
import type { PageContext } from '../types/chatbot'

export function usePageContext() {
  const route = useRoute()
  const rcStore = useResidentialComplexStore()
  const articlesStore = useArticlesStore()

  const pageContext = computed<PageContext>(() => {
    const routeName = route.name as string

    switch (routeName) {
      case ROUTES.PROPERTY_DETAIL: {
        const rc = rcStore.currentComplex
        return {
          type: 'residential_complex',
          slug: route.params.slug as string,
          id: rc?.id,
          title: rc?.name,
        }
      }

      case ROUTES.NEWS_DETAIL:
      case ROUTES.HANDBOOK_DETAIL:
      case ROUTES.SERVICES_DETAIL: {
        const article = articlesStore.currentArticle
        return {
          type: 'article',
          slug: route.params.slug as string,
          id: article?.id,
          title: article?.title,
          articleType: route.meta.articleType as number | undefined,
        }
      }

      case ROUTES.PROPERTIES_CATALOG:
      case ROUTES.PROPERTIES_CATALOG_BY_CITY:
        return {
          type: 'catalog',
          pageName: 'properties',
        }

      case ROUTES.NEWS:
      case ROUTES.HANDBOOK:
      case ROUTES.SERVICES:
        return {
          type: 'catalog',
          pageName: routeName,
        }

      default:
        return {
          type: 'general',
          pageName: routeName || 'unknown',
        }
    }
  })

  return { pageContext }
}
